<div class="modal-dialog">
  <div class="modal-content">
    <!-- Overlay -->
    <div *ngIf="isLoading" class="overlay d-flex justify-content-center align-items-center">
      <div class="glass-loader p-4 rounded-3">
        <i class="fas fa-spinner fa-spin text-white"></i>
      </div>
    </div>
    <!-- Header -->
    <div class="modal-header border-0 pb-0">
      <h5 class="modal-title fw-semibold">{{ '::Feedback:AgentSummary' | abpLocalization }}</h5>
      <button type="button" (click)="closeModal()" class="btn-close" aria-label="Close"></button>
    </div>

    <!-- Body -->
    <div class="modal-body pt-4">
      <!-- Agent info -->
      <div class="d-flex align-items-center mb-4">
        <ca-user-photo
          [useCurrentUser]="false"
          [userId]="agentId"
          [nameAndSurname]="agentSummary?.fullName?.split(' ')"
          [classes]="['agent-summary-image shadow-sm']"></ca-user-photo>
        <div class="ms-2">
          <h6 class="mb-0 fw-semibold" style="font-size: 18px">{{ agentSummary?.fullName }}</h6>
          <small>{{ agentSummary?.departmentName }}</small>
        </div>
      </div>

      <div class="mb-3">
        <h5 class="mb-2">{{ '::Feedback:TimePeriod' | abpLocalization }}</h5>
        <div class="d-flex gap-2">
          <button
            class="btn period-btn"
            [class.active]="selectedPeriod === 7"
            (click)="changePeriod(7)">
            {{ '::Feedback:Last7Days' | abpLocalization }}
          </button>
          <button
            class="btn period-btn"
            [class.active]="selectedPeriod === 30"
            (click)="changePeriod(30)">
            {{ '::Feedback:Last30Days' | abpLocalization }}
          </button>
        </div>
      </div>

      <!-- Statistics and Feedback Message -->
      <div class="row">
        <!-- Statistics Column -->
        <div class="col-md-6 mb-3 d-flex flex-column">
          <h5 class="fw-semibold mb-3">{{ '::Feedback:Statistics' | abpLocalization }}</h5>

          <!-- Feedback Count Card -->
          <div class="card border p-3 flex-fill">
            <p class="text-center mb-3 small">
              {{ '::Feedback:FeedbackCount' | abpLocalization }}
            </p>
            <div class="d-flex justify-content-center gap-5">
              <div class="text-center">
                <h3 class="text-primary fw-bold mb-0">{{ agentSummary?.feedbackUnreadCount }}</h3>
                <small>{{ '::Feedback:Unread' | abpLocalization }}</small>
              </div>
              <div class="text-center">
                <h3 class="fw-bold mb-0 text-green">
                  {{ agentSummary?.feedbackReadCount }}
                </h3>
                <small>{{ '::Feedback:Read' | abpLocalization }}</small>
              </div>
            </div>
          </div>

          <!-- Duration Card -->
          <div class="card border mt-3 p-3 flex-fill">
            <div class="d-flex justify-content-around align-items-center">
              <!-- Average Call Duration -->
              <div class="text-center">
                <h3 class="text-primary mb-1">
                  {{
                    !agentSummary?.averageCallDuration
                      ? '0'
                      : formatHelper.convertSecondToString(agentSummary?.averageCallDuration)
                  }}
                </h3>

                <div
                  *ngIf="agentSummary?.averageCallDurationChange !== 0"
                  [ngClass]="{
                    'text-danger': agentSummary?.averageCallDurationChange > 0,
                    'text-green': agentSummary?.averageCallDurationChange < 0
                  }">
                  <ng-container *ngIf="agentSummary?.averageCallDurationChange > 0">+</ng-container>
                  {{ agentSummary?.averageCallDurationChange | number : '1.1-1' }}%
                </div>

                <small class="d-block mt-1">
                  {{ '::Feedback:AverageCall' | abpLocalization }}
                  <br />
                  {{ '::Feedback:Duration' | abpLocalization }}
                </small>
              </div>

              <!-- Average Silence Duration -->
              <div class="text-center">
                <h3 class="text-primary mb-1">
                  {{
                    !agentSummary?.averageSilenceDuration
                      ? '0'
                      : formatHelper.convertSecondToString(agentSummary?.averageSilenceDuration)
                  }}
                </h3>

                <div
                  *ngIf="agentSummary?.averageSilenceDurationChange !== 0"
                  [ngClass]="{
                    'text-danger': agentSummary?.averageSilenceDurationChange > 0,
                    'text-green': agentSummary?.averageSilenceDurationChange < 0
                  }">
                  <ng-container *ngIf="agentSummary?.averageSilenceDurationChange > 0">
                    +
                  </ng-container>
                  {{ agentSummary?.averageSilenceDurationChange | number : '1.1-1' }}%
                </div>

                <small class="d-block mt-1">
                  {{ '::Feedback:AverageSilence' | abpLocalization }}
                  <br />
                  {{ '::Feedback:Duration' | abpLocalization }}
                </small>
              </div>
            </div>
          </div>
        </div>

        <!-- Feedback Message Column -->
        <div class="col-md-6 mb-3 d-flex flex-column">
          <h5 class="fw-semibold mb-3">{{ '::Feedback:FeedbackMessage' | abpLocalization }}</h5>
          <textarea
            class="shadow-sm form-control border flex-grow-1"
            [(ngModel)]="feedbackMessage"
            placeholder="{{ '::Feedback:EnterFeedback' | abpLocalization }}"
            style="resize: none"
            maxlength="500"></textarea>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer border-0 pt-2">
      <button type="button" (click)="closeModal()" class="btn btn-primary px-4">
        {{ 'AbpUi::Cancel' | abpLocalization }}
      </button>
      <button
        type="button"
        [disabled]="feedbackMessage.trim().length <= 0"
        class="btn btn-primary px-4"
        (click)="saveFeedback()">
        {{ '::Save' | abpLocalization }}
      </button>
    </div>
  </div>
</div>
